import classnames from 'classnames';
import React from 'react';

import css from 'reactApp/components/icons/IconWarning.css';
import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

export function IconWarning({
    width = '57',
    height = '49',
    className,
    ...rest
}: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 57 49"
            className={classnames(css.main, className)}
            {...rest}
        >
            <g
                id="Balance"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="Balance-error"
                    transform="translate(-697.000000, -410.000000)"
                    className={css.colored}
                >
                    <path
                        d="M752.463275,450.518455 L729.628696,412.393231 C727.520889,409.301997 722.953974,409.301997 720.846166,412.393231 L698.011588,450.518455 C695.903781,453.953159 698.362889,458.074805 702.578504,458.074805 L748.598961,458.074805 C752.111973,458.074805 754.571082,453.609689 752.463275,450.518455 L752.463275,450.518455 Z M725.5,452 C723.4,452 722,450.444444 722,448.5 C722,446.555556 723.4,445 725.5,445 C727.6,445 729,446.555556 729,448.5 C729,450.444444 727.6,452 725.5,452 L725.5,452 Z M729,439.28 C729,440.64 727.6,442 726.2,442 L724.8,442 C723.4,442 722,440.64 722,439.28 L722,427.72 C722,426.36 723.4,425 724.8,425 L726.2,425 C727.6,425 729,426.36 729,427.72 L729,439.28 L729,439.28 Z"
                        id="Shape"
                    />
                </g>
            </g>
        </svg>
    );
}
